module.exports = __webpack_public_path__ + "static/media/upload-success.59cdde62.svg";